import { Trans } from "@lingui/react/macro"
import type { FallbackProps } from "react-error-boundary"

export const ErrorMessage = (props: FallbackProps) => (
  <div>
    <Trans>Something went wrong: </Trans>
    {props.error instanceof Error ? props.error.message : null}
  </div>
)
